import React from "react";
import { ForceRedirect } from "../../../../components";
import { envs } from "../../../../config";

const HomePage = () => {
  // a partir da transição de marca, o runoff de consórcio deixa de existir, todas as requisições
  // com exceção de alguns arquivos não mapeados no runoff serão redirecionados a cnp consorcio
  return <ForceRedirect uri={envs.hostCnpConsorcios} />;
};

export default HomePage;
